import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import TextField from '@material-ui/core/TextField';

class PresentationDialog extends React.Component {
    state = {
        value: this.props.value,
        open: undefined,
    };

    handleChange = (event) => {
        const { value } = this.state;
        value[event.target.name] = event.target.value;
        this.setState({ value: value });
    };

    handleClose = (value) => (event) => {
        this.props.onClose(value);
    };

    render() {
        const { value } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            id={'nombre'}
                            name={'nombre'}
                            label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                            className={'flex_full_row'}
                            value={value.nombre}
                            onChange={this.handleChange}
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={this.handleClose(value)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default PresentationDialog;



// WEBPACK FOOTER //
// ./src/components/complex/manage/reference/Dialog.js